/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Tab_AllInputs */

const en_admin_payments_tab_all = /** @type {(inputs: Admin_Payments_Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const zh_admin_payments_tab_all = /** @type {(inputs: Admin_Payments_Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Admin_Payments_Tab_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_tab_all = /** @type {((inputs?: Admin_Payments_Tab_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Tab_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_tab_all(inputs)
	return zh_admin_payments_tab_all(inputs)
});
export { admin_payments_tab_all as "admin.payments.tab_all" }